import { render, staticRenderFns } from "./workDayFx1.vue?vue&type=template&id=94149266&scoped=true"
import script from "./workDayFx1.vue?vue&type=script&lang=js"
export * from "./workDayFx1.vue?vue&type=script&lang=js"
import style0 from "./workDayFx1.vue?vue&type=style&index=0&id=94149266&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94149266",
  null
  
)

export default component.exports